@if (customerServiceWorkspace()) {
  <main class="customer-service-workspace"><router-outlet /></main>
} @else {
@if (ssoAuthWorkspace()) {
  <main class="sso-auth-workspace"><router-outlet /></main>
} @else {
<main class="shell"
  [class.theme-editor-workspace]="themeEditorWorkspace()"
  [class.theme-storefront-workspace]="themeStorefront() || !!themePresentation()"
  [class.vet-public-shell]="vetPublicShell()"
  [class.clinic-public-shell]="clinicPublicShell()">
  <app-unsupported-locale-notice />
  @if (!sellerWorkspace() && !adminWorkspace() && !qrMarketplaceWorkspace() && !themeStorefront() && !themePresentation() && !vetPublicShell() && !clinicPublicShell()) {
    <app-site-header />
  }
  @if (vetPublicShell()) { <app-vet-site-header /> }
  @if (clinicPublicShell()) { <app-clinic-site-header /> }
  @if (!sellerWorkspace() && !adminWorkspace() && site.config().subscriptionExpired) {
    <aside class="subscription-expired-site" role="status">
      <div><strong>Abonelik süresi doldu</strong><span>Bu sitenin hizmetlerini kullanmaya devam etmek için aboneliği yenileyin.</span></div>
      <a href="https://www.aymudo.com/solutions/kuafor">Tekrar aktif et</a>
    </aside>
  }
  @if (pageData.routeLoading()) {
    <div class="route-loading" aria-live="polite">
      <div class="route-loading-card">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  }
  @if (themeStorefront()) {
    <app-theme-storefront />
  } @else if (themePresentation(); as theme) {
    <div class="theme-storefront theme-core-page" [attr.data-theme-id]="theme.themeId" [attr.data-theme-version]="theme.themeVersion" [attr.data-theme-template]="theme.template" [attr.data-page-layout]="themePageOptions()['layout'] || 'grid'" [attr.data-hero-style]="themePageOptions()['hero_style'] || 'banner'" [attr.data-card-style]="themePageOptions()['card_style'] || 'soft'" [attr.data-content-width]="themePageOptions()['content_width'] || 'standard'" [attr.data-page-density]="themePageOptions()['density'] || 'comfortable'" [attr.data-heading-scale]="themePageOptions()['heading_scale'] || 'large'" [class.is-preview]="theme.preview"
      [style.--theme-primary]="theme.tokens['primary']" [style.--theme-background]="theme.tokens['background']" [style.--theme-surface]="theme.tokens['surface']" [style.--theme-text]="theme.tokens['text']" [style.--theme-radius]="theme.tokens['radius']" [style.--theme-container]="theme.tokens['container']" [style.--theme-font-display]="theme.tokens['font_display']" [style.--theme-font-body]="theme.tokens['font_body']"
      [style.--theme-light-primary]="theme.tokens['light_primary'] || theme.tokens['primary']" [style.--theme-light-background]="theme.tokens['light_background'] || theme.tokens['background']" [style.--theme-light-surface]="theme.tokens['light_surface'] || theme.tokens['surface']" [style.--theme-light-text]="theme.tokens['light_text'] || theme.tokens['text']" [style.--theme-dark-primary]="theme.tokens['dark_primary'] || theme.tokens['primary']" [style.--theme-dark-background]="theme.tokens['dark_background'] || theme.tokens['background']" [style.--theme-dark-surface]="theme.tokens['dark_surface'] || theme.tokens['surface']" [style.--theme-dark-text]="theme.tokens['dark_text'] || theme.tokens['text']"
      [style.--accent]="theme.tokens['primary']" [style.--paper]="theme.tokens['background']" [style.--surface]="theme.tokens['surface']" [style.--card]="theme.tokens['surface']" [style.--ink]="theme.tokens['text']" [style.--font-display]="theme.tokens['font_display']" [style.--font-body]="theme.tokens['font_body']">
      <app-site-header />
      <div class="theme-core-content">
        <app-theme-page-sections position="before" [anchorTypes]="themeAnchorTypes()" />
        <router-outlet />
        <app-theme-page-sections position="after" [anchorTypes]="themeAnchorTypes()" />
      </div>
      <app-site-footer />
    </div>
  } @else {
    <router-outlet />
  }
  @if (clinicPublicShell()) {
    <app-clinic-site-footer />
  } @else if (vetPublicShell()) {
    <app-vet-site-footer />
  } @else if (!sellerWorkspace() && !adminWorkspace() && !qrMarketplaceWorkspace() && !themeStorefront() && !themePresentation()) {
    <app-site-footer />
  }
</main>
<app-scroll-top />
<app-live-call-overlay />
@if (site.enabled('guidedActions')) {
  <app-guided-action-widget />
}
<app-live-support-agent-widget />
@if (!sellerWorkspace() && !adminWorkspace()) {
  <app-live-support-widget />
}
@if (!sellerWorkspace() && !adminWorkspace()) {
  <app-cookie-consent />
}
}

}
